import { string, func, bool, oneOfType, number } from 'prop-types'
import Div from '@ui/layout/Div'
import Alert from '@ui/elements/Alert'

const SwitcherType = ({
  name,
  value,
  onClick,
  cssClass,
  switcherClass = 'is-rounded is-outlined',
  label,
  help,
  id = null,
  error,
  isRequired
}) => {
  return (
    <Div cssClass={`field switcher-field ${cssClass ?? ''}`}>
      <input id={`${null !== id ? id : `switch-${name}`}`} type="checkbox" name={name} className={`switch ${switcherClass}`} checked={parseInt(value) === 1} onClick={onClick} value={parseInt(value) === 1 ? 0 : 1} onChange={() => { }} />
      <label className="label" htmlFor={`${null !== id ? id : `switch-${name}`}`}>
        <span className={isRequired ? 'is-required' : ''}>{label}</span>
      </label>
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
      {help ? <p className="help">{help}</p> : ''}
    </Div>
  )
}

SwitcherType.propTypes = {
  name: string,
  onClick: func,
  cssClass: string,
  help: string,
  label: string,
  switcherClass: string,
  value: oneOfType([bool, number]),
  id: string,
  error: string,
  isRequired: bool
}

export default SwitcherType
